import { render, staticRenderFns } from "./features25.vue?vue&type=template&id=c1e925e8&scoped=true"
import script from "./features25.vue?vue&type=script&lang=js"
export * from "./features25.vue?vue&type=script&lang=js"
import style0 from "./features25.vue?vue&type=style&index=0&id=c1e925e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e925e8",
  null
  
)

export default component.exports